import React from 'react';

import venmo from '../../../images/venmo.JPEG';
import zelle from '../../../images/zelle.JPEG';
import cashApp from '../../../images/cashApp.JPEG';
import paypal from '../../../images/paypal.JPEG';
import applePay from '../../../images/applePay.JPEG';

import './index.scss';

const Contact = () => {
	return (
		<div className='contact-section-wrapper contact'>
			<h3>Contact Us</h3>
			<p>Contact us to make a reservation</p>
			<p>or get more information about any of our services </p>
			<div className='contact-number'>
				<a href='tel:+16315982388'>1(631) 598-2388</a>
			</div>
			<div className='supported-payment'>
				<img src={applePay} alt='' />
				<img src={venmo} alt='' />
				<img src={zelle} alt='' />
				<img src={cashApp} alt='' />
				<img src={paypal} alt='' />
			</div>
		</div>
	);
};

export default Contact;
